// LandingRouter.jsx
// Provides routing for the home page and dynamic issue storytelling pages.
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import StoryScrollScreen from '../screens/StoryScrollScreen';
import HomeScreen from '../screens/HomeScreen';
import { ISSUES, findIssueBySlug } from '../issues';

/**
 * LandingRouter
 * Renders the story-driven landing experience for all routes.
 */
export default function LandingRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomeScreen issues={ISSUES} />} />
      <Route path="/:stateSlug/:issueSlug" element={<IssueRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

/**
 * IssueRoute
 * Loads the issue content based on the URL and renders the storytelling screen.
 */
function IssueRoute() {
  const { stateSlug, issueSlug } = useParams();
  const issue = findIssueBySlug(stateSlug, issueSlug);

  if (!issue) {
    return <Navigate to="/" replace />;
  }

  return (
    <StoryScrollScreen
      bills={issue.bills}
      groups={issue.groups}
      barrierStories={issue.barrierStories}
      content={issue.storyScroll}
    />
  );
}
